import PropTypes from 'prop-types';
import TopSportsControllerViewImpl from './top-sports-controller-view.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A module that displays sports based on the provided configuration.
 *
 * @class TopSportsControllerView
 * @name TopSports
 * @memberof Mojito.Modules
 */

/**
 * `TopSportsControllerView` prop types.
 *
 * @property {string} [navigationTitle] - The title displayed in the navigation header of the Top Sports view.
 *
 * @memberof Mojito.Modules.TopSports
 */
const propTypes = {
    navigationTitle: PropTypes.string,
};

export default UIView('TopSportsControllerView', TopSportsControllerViewImpl, propTypes);
